import { LogoWhiteSVG } from 'assets/svg';

import { Component } from 'types-common';

import { HeaderCentered, HeaderRoot, Logo } from './Header.syled';

export const LeanHeader: Component = () => (
  <HeaderRoot>
    <HeaderCentered>
      <Logo>
        <LogoWhiteSVG />
      </Logo>
    </HeaderCentered>
  </HeaderRoot>
);
